import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state = {
    ordersList: [], // 首页列表
    detailsList: [], // 详情列表
    detailsListCount: 0, // 详情列表所有数据条数
    contactsList: [], // 联系人列表
    shareableContactsList: [], // 可共享联系人列表
    sharedContactsList: [], // 已共享联系人列表
    escSearchIcon: false, // 退出搜索按钮
    toolsClassifyList: [], //左侧菜单项里“工具下载”菜单项下面的子菜单项
    isLoading: false
};

export const modulesName = "config";

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/config/index.js